import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import lazyLoading from '../modules/lazyLoading';

gsap.registerPlugin(ScrollTrigger);

const $homePeopleList = document.querySelector('.home-people__items');
const $homeVideo = document.querySelectorAll('.home video');

const homePeopleListHTML = $homePeopleList.innerHTML;

const vh = (value) => (innerHeight * value) / 100;

const loadLazyPeopleImagesOnDesktop = () => {
	if (innerWidth >= 768) {
		$homePeopleList
			.querySelectorAll('.js-lazy')
			.forEach(($jsLazyCurrent) => {
				lazyLoading.trigger($jsLazyCurrent);
			});
	}
};

const videoAutoplayOnScroll = () => {
	if (!$homeVideo.length) {
		return;
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting && entry.target.paused) {
				entry.target.play();
			} else {
				entry.target.pause();
			}
		});
	});

	$homeVideo.forEach(($homeVideoCurrent) => {
		observer.observe($homeVideoCurrent);
	});
};

const cardCoverToggleVisibilityOnScroll = () => {
	if (innerWidth < 768) {
		return;
	}

	const $cover = document.querySelectorAll('.home-people__cover');

	if (!$cover.length) {
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target
						.querySelector('picture')
						.classList.remove('is-hidden');
				} else {
					entry.target
						.querySelector('picture')
						.classList.add('is-hidden');
				}
			});
		},
		{
			rootMargin: `${innerHeight}px 0px`,
		}
	);

	$cover.forEach(($coverCurrent) => {
		observer.observe($coverCurrent);
	});
};

const createHomePeopleListCols = () => {
	if (innerWidth < 768) {
		if ($homePeopleList.classList.contains('is-cols')) {
			$homePeopleList.classList.remove('is-cols');

			$homePeopleList.innerHTML = homePeopleListHTML;
		}

		return;
	}

	if ($homePeopleList.classList.contains('is-cols')) {
		return;
	}

	$homePeopleList.classList.add('is-cols');

	$homePeopleList.innerHTML = `
		<div class="home-people__col">
			<div class="home-people__col-inner">
				${[...document.querySelectorAll('.home-people__item:nth-child(3n+1)')]
					.map(($itemCurrent) => $itemCurrent.outerHTML)
					.join('')}
			</div>
		</div>
		<div class="home-people__col">
			<div class="home-people__col-inner">
				${[...document.querySelectorAll('.home-people__item:nth-child(3n+2)')]
					.map(($itemCurrent) => $itemCurrent.outerHTML)
					.join('')}
			</div>
		</div>
		<div class="home-people__col">
			<div class="home-people__col-inner">
				${[...document.querySelectorAll('.home-people__item:nth-child(3n+3)')]
					.map(($itemCurrent) => $itemCurrent.outerHTML)
					.join('')}
			</div>
		</div>
	`;
};

const cardSettings = (value) => {
	return {
		trigger: '.home-people',
		start: 'top bottom',
		end: `bottom-=${value} bottom`,
		scrub: 1,
	};
};

const resize = () => {
	if (window.widthScroll === innerWidth) {
		return;
	}

	window.widthScroll = innerWidth;

	createHomePeopleListCols();
	cardCoverToggleVisibilityOnScroll();

	$homePeopleList.querySelectorAll('.js-lazy').forEach(($jsLazyCurrent) => {
		lazyLoading.trigger($jsLazyCurrent);
	});
};

function init() {
	createHomePeopleListCols();
	cardCoverToggleVisibilityOnScroll();
	videoAutoplayOnScroll();
	loadLazyPeopleImagesOnDesktop();

	$('.home-hero').addClass('is-active');

	ScrollTrigger.matchMedia({
		'(min-width: 320px)': () => {
			ScrollTrigger.create({
				trigger: '.home-people',
				start: 'top top',
				end: 'bottom',
				toggleClass: 'is-active',
			});
		},
		'(min-width: 768px)': () => {
			const homePeopleItemLength =
				document.querySelectorAll('.home-people__item').length;

			const vhDepLen = (value) => vh((value / 69) * homePeopleItemLength); // 69 - кол-во карточек на момент актуального контента

			ScrollTrigger.create({
				trigger: '.footer',
				start: 'top top',
				end: 'bottom',
				toggleClass: {
					targets: '.header',
					className: 'is-hide',
				},
			});

			gsap.to('.home-hero__line--item-1 .home-hero__line-inner', {
				scrollTrigger: {
					trigger: '.home-hero',
					start: 'top top',
					end: 'bottom',
					scrub: true,
				},
				ease: 'none',
				y: -20,
			});

			gsap.to('.home-hero__line--item-2 .home-hero__line-inner', {
				scrollTrigger: {
					trigger: '.home-hero',
					start: 'top top',
					end: 'bottom',
					scrub: true,
				},
				ease: 'none',
				y: -76,
			});

			gsap.to('.home-people__col:nth-child(1) .home-people__col-inner', {
				scrollTrigger: cardSettings(vhDepLen(85)),
				ease: 'none',
				y: vhDepLen(-85),
			});

			gsap.to('.home-people__col:nth-child(2) .home-people__col-inner', {
				scrollTrigger: cardSettings(vhDepLen(10)),
				ease: 'none',
				y: vhDepLen(-10),
			});

			gsap.to('.home-people__col:nth-child(3) .home-people__col-inner', {
				scrollTrigger: cardSettings(vhDepLen(110)),
				ease: 'none',
				y: vhDepLen(-110),
			});

			ScrollTrigger.create({
				trigger: '.home-people__items',
				start: `bottom-=${vhDepLen(75)} bottom`,
				end: `+=${vhDepLen(75)}`,
				pin: '.home-people__col:nth-child(1)',
			});

			ScrollTrigger.create({
				trigger: '.home-people__items',
				start: `bottom-=${vhDepLen(100)} bottom`,
				end: `+=${vhDepLen(100)}`,
				pin: '.home-people__col:nth-child(3)',
			});
		},
	});

	window.widthScroll = innerWidth;

	window.addEventListener('resize', resize, false);
}

export default {
	init,
};
